const SvgCaretDown = ({ width = 16, height = 9, className, ...props }) => (
  <svg className={className} width={width} height={height} viewBox="0 0 16 9" fill="none" {...props}>
    <path
      d="M0.999998 1L8 8L15 1"
      stroke="currentColor"
      strokeWidth={2.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgCaretDown;
